import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='#about'
      className='link footer__link'
    >
      Created By Álvaro Fuentenebro
    </a>
  </footer>
)

export default Footer